export const SEARCH_PERFORMANCE_CARD_TITLE = 'Search Performance';
export const SEARCH_PERFORMANCE_CARD_DESCRIPTION = "See Prerender's data with Google Search Performance signals.";
